import {Component, inject, Input, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ToastAlertSignalStore} from '../../shared/store/alert/toast-alert.signal-store';
import {FormsModule} from '@angular/forms';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {OfferService} from '../../shared/service/offer.service';
import {SpinnerService} from '../../shared/service/spinner.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'ucs-offer-notes',
  imports: [
    TranslatePipe,
    FormsModule,
    CdkTextareaAutosize,
  ],
  templateUrl: './offer-notes.component.html',
  styleUrl: './offer-notes.component.scss'
})
export class OfferNotesComponent implements OnInit {
  @Input() offer: BuyNowOfferDto & AuctionOfferDto & EnforcedAuctionOfferDto;

  offerNote: string = '';
  readonly toastAlertStore = inject(ToastAlertSignalStore);
  protected isEditing = false;

  constructor(private translateService: TranslateService,
              private spinnerService: SpinnerService,
              private offerService: OfferService) {
  }

  ngOnInit(): void {
    if (this.offer.note) {
      this.offerNote = this.offer.note.note;
    }
  }

  /**
   * Save a note to an offer, if it is non-empty
   */
  saveNote() {
    if (this.offerNote) {
      this.spinnerService.spinner(
        this.offerService.addOfferNote(this.offer.id, this.offerNote)
      ).pipe(first()).subscribe({
        next: (savedNote) => {
          this.offer.note = savedNote;
          this.toastAlertStore.success(this.translateService.instant('offer-notes.add.success'));
        }, error: () => {
          this.toastAlertStore.danger(this.translateService.instant('offer-notes.add.error'));
        }
      });
    } else if (this.offer.note) {
      this.spinnerService.spinner(
        this.offerService.deleteOfferNote(this.offer.id, this.offer.note?.id)
      ).pipe(first()).subscribe({
        next: () => {
          this.offer.note = undefined;
          this.toastAlertStore.success(this.translateService.instant('offer-notes.delete.success'));
        }, error: () => {
          this.toastAlertStore.danger(this.translateService.instant('offer-notes.delete.error'));
        }
      });
    }
  }
}
